<abp-page [title]="'Inventory::AssetComponents' | abpLocalization">
  <abp-page-toolbar-container class="col">
    <div class="text-lg-end pt-2">
      <button
        *abpPermission="'Inventory.AssetComponents.Create'"
        class="btn btn-primary btn-sm"
        type="button"
        (click)="create()"
      >
        <i class="fa fa-plus me-1" aria-hidden="true"></i>
        {{ 'Inventory::NewAssetComponent' | abpLocalization }}
      </button>
    </div>
  </abp-page-toolbar-container>

  <abp-advanced-entity-filters localizationSourceName="Inventory" [list]="list">
    <abp-advanced-entity-filters-form>
      <form #filterForm (keyup.enter)="list.get()">
        <div class="row">
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="codeFilter">
                {{ 'Inventory::Code' | abpLocalization }}
              </label>

              <input
                id="codeFilter"
                class="form-control"
                [(ngModel)]="filters.code"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="assetIdFilter">
                {{ 'Inventory::Asset' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="assetIdFilter"
                displayNameProp="name"
                lookupNameProp="displayName"
                [getFn]="service.getAssetLookup"
                [(ngModel)]="filters.assetId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="componentIdFilter">
                {{ 'Inventory::Component' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="componentIdFilter"
                displayNameProp="name"
                lookupNameProp="displayName"
                [getFn]="service.getComponentLookup"
                [(ngModel)]="filters.componentId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>

          <div class="col-12 col-sm-auto align-self-end mb-3">
            <div class="row">
              <div class="col-6 col-sm-auto d-grid">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  (click)="clearFilters()"
                >
                  <span>{{ 'AbpUi::Clear' | abpLocalization }}</span>
                </button>
              </div>
              <div class="col-6 col-sm-auto d-grid">
                <button type="button" class="btn btn-primary" (click)="list.get()">
                  <span>{{ 'AbpUi::Refresh' | abpLocalization }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </abp-advanced-entity-filters-form>
  </abp-advanced-entity-filters>

  <div class="card">
    <div class="card-body">
      <ngx-datatable [rows]="data.items" [count]="data.totalCount" [list]="list" default>
        <ngx-datatable-column
          [name]="'AbpUi::Actions' | abpLocalization"
          [maxWidth]="150"
          [width]="150"
          [sortable]="false"
        >
          <ng-template let-row="row" let-i="rowIndex" ngx-datatable-cell-template>
            <div ngbDropdown container="body" class="d-inline-block">
              <button
                class="btn btn-primary btn-sm dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                ngbDropdownToggle
              >
                <i class="fa fa-cog me-1" aria-hidden="true"></i>
                {{ 'AbpUi::Actions' | abpLocalization }}
              </button>

              <div ngbDropdownMenu>
                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.AssetComponents.Edit'"
                  (click)="update(row)"
                >
                  {{ 'AbpUi::Edit' | abpLocalization }}
                </button>

                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.AssetComponents.Delete'"
                  (click)="delete(row)"
                >
                  {{ 'AbpUi::Delete' | abpLocalization }}
                </button>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Code' | abpLocalization }}" prop="assetComponent.code">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.assetComponent.code }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Asset' | abpLocalization }}" prop="asset.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.asset?.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Component' | abpLocalization }}" prop="component.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.component?.name }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</abp-page>

<abp-modal [busy]="isModalBusy" [(visible)]="isModalOpen">
  <ng-template #abpHeader>
    <h3>
      {{ (selected ? 'AbpUi::Edit' : 'Inventory::NewAssetComponent') | abpLocalization }}
    </h3>
  </ng-template>

  <ng-template #abpBody>
    <form [formGroup]="form" (ngSubmit)="submitForm()" validateOnSubmit>
      <div class="mt-2 fade-in-top">
        <div class="mb-3">
          <label class="form-label" for="asset-component-code">
            {{ 'Inventory::Code' | abpLocalization }} *
          </label>

          <input
            id="asset-component-code"
            formControlName="code"
            class="form-control"
            autofocus
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-component-asset-id">
            {{ 'Inventory::Asset' | abpLocalization }} *
          </label>
          <abp-lookup-input
            cid="asset-component-asset-id"
            formControlName="assetId"
            displayNameProp="name"
            lookupNameProp="displayName"
            [getFn]="service.getAssetLookup"
            [editingData]="selected?.asset"
          ></abp-lookup-input>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-component-component-id">
            {{ 'Inventory::Component' | abpLocalization }} *
          </label>
          <abp-lookup-input
            cid="asset-component-component-id"
            formControlName="componentId"
            displayNameProp="name"
            lookupNameProp="displayName"
            [getFn]="service.getComponentLookup"
            [editingData]="selected?.component"
          ></abp-lookup-input>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Cancel' | abpLocalization }}
    </button>

    <abp-button iconClass="fa fa-check" (click)="submitForm()" [disabled]="form?.invalid">
      {{ 'AbpUi::Save' | abpLocalization }}
    </abp-button>
  </ng-template>
</abp-modal>
